<template>
  <div v-if="total > 1" class="pagination">
    <div
      class="icon d-inline-block icon-arrow-left"
      :class="{'disabled': current == 1}"
      @click="prev"
    ></div>
    <div class="text d-inline-block ml-3 mr-2">Page</div>
    <div class="element d-inline-block">
      <input type="text" name="current" class="form-control" v-model="current" />
    </div>
    <div class="text d-inline-block ml-2 mr-3">of {{ total }}</div>
    <div
      class="icon d-inline-block icon-arrow-right"
      :class="{'disabled': current == total}"
      @click="next"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    total: { type: Number, default: 1 },
    value: { type: Number, default: 1 }
  },
  data() {
    return {
      current: 1
    };
  },
  watch: {
    value(val) {
      this.current = val;
    },
    current(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    prev() {
      if (this.current > 1) {
        this.current = this.current - 1;
      }
    },
    next() {
      if (this.current < this.total) {
        this.current = this.current + 1;
      }
    }
  },
  created() {
    this.current = this.value;
  }
};
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/_functions";
@import "bootstrap/scss/_variables";
input {
  color: gray("700");
  font-size: 0.875rem;
  text-align: center;
  width: 48px;
}
.icon {
  color: gray("600");
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 35px;
  &.disabled {
    cursor: default;
    color: gray("500");
  }
}
.text {
  color: gray("600");
  font-size: 0.875rem;
  line-height: 35px;
}
</style>